export const environment = {
  production: true,
  enabledLanguages: ['nl-NL'],
  testEnabledLanguages: ['en-GB', 'nl-NL'],
  defaultLanguage: 'en-GB',
  angularLanguageLocaleMap: { 'nl-NL': 'nl-NL', 'en-GB': 'en-GB' },
  showLogoAboveNavigation: true,
  auth0Tenant: {
    baseUrl: 'https://cdn.eu.auth0.com',
    clientId: 'RLVu2fgOKDk0Zra80yS1DV5PDleoB7n5',
    domain: 'login.doenkids.nl',
    audience: 'https://api.doenkids.nl',
    title: 'Ovivio Activities',
    logoUrl: './assets/images/logo-ovivio.png',
    themeColor: '#dd1571',
  },
};
